import { ITab } from '../../../_models/tabsInterface'

export const footerLinks: ITab[] = [
  {
    id: 1,
    label: 'commonPageLayout.contact',
    path: '/customer/business',
  },
  {
    id: 2,
    label: 'commonPageLayout.faq',
    path: '/customer/business',
  },
  {
    id: 3,
    label: 'commonPageLayout.blog',
    path: '/customer/business',
  },
]
